import React from "react";

function BlogArrowIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#101828"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M7 17L17 7m0 0H7m10 0v10"
      ></path>
    </svg>
  );
}

export default BlogArrowIcon;